import { useTranslation } from 'react-i18next';

import {
    Flex,
    IconReport,
    TextButton,
} from '@myphx-engineering/phx-design-system';

type NotCoveredAlertProps = {
    toggle?: () => void;
};

export const NotCoveredAlert = ({ toggle }: NotCoveredAlertProps) => {
    const { t } = useTranslation();

    return (
        <Flex>
            <TextButton
                LeftIcon={IconReport}
                color="warning"
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    toggle?.();
                }}
            >
                {t('common.drugCoverageAlerts.notCovered.buttonText')}
            </TextButton>
        </Flex>
    );
};
